/**
 * Budget Allocation Controller
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('BudgetAllocationController', [
    '$scope',
    'BudgetAllocation',
    function($scope, BudgetAllocation){

    /**
     * Loading state
     *
     * @type {Boolean}
     */
    $scope.loading = false;

    /**
     * Define starting data
     *
     * @type {Object}
     */
    $scope.data = {
        headers: [],
        groups:[],
        budgets:[],
    }

    /**
     * Define Budget Groups
     *
     * @type {Array}
     */
    $scope.budgetGroups = [];

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        this.load({
            brand: brand || $scope.$parent.brand,
            from : from || $scope.$parent.from,
            to   : to || $scope.$parent.to,
        });
    }

    /**
     * Load the data
     *
     * @param  {object} query
     * @return void
     */
    $scope.load = function(query) {
        /* Enable loader */
        $scope.loading = true;
        /* fetch data */
        BudgetAllocation
            .get(query)
            .$promise
            .then(function(response, headers){
                /* Replace the data*/
                $scope.data = response.data;
                /* Disable loader */
                $scope.loading = false;
                /* Group the results */
                $scope.setBudgetGroups();
            }, function(response, headers){
                _.each(response.data, function(error){
                    $.publish('resource.error', error);
                });
            });
    }

    /**
     * Deep Sum
     *
     * @param  string           groupBy
     * @return float
     */
    $scope.sumBy = function(field) {
        return _.sumBy(this.data.budgets, field);
    }

    /**
     * When loaded we would group the budget by their type
     *
     * @return (Object): Returns the composed aggregate object.
     */
    $scope.setBudgetGroups = function() {
        $scope.budgetGroups = _.groupBy($scope.data.budgets, function($value){
            return _.get($value, 'budget_type.id');
        });
    }
}]);
